import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			//首页
			path: '/privacy',
			name: 'privacy',
			component: (resolve) => require(['@/views/Privacy.vue'], resolve),
		},
		{
			//首页
			path: '/aboutUs',
			name: 'aboutUs',
			component: (resolve) => require(['@/views/aboutUs.vue'], resolve),
		},
		{
			//首页
			path: '/legalPerson',
			name: 'legalPerson',
			component: (resolve) => require(['@/views/legalPerson.vue'], resolve),
		},
		{
			//首页
			path: '/offers',
			name: 'offers',
			component: (resolve) => require(['@/views/offers.vue'], resolve),
		},
		{
			//首页
			path: '/cooperate',
			name: 'cooperate',
			component: (resolve) => require(['@/views/cooperate.vue'], resolve),
		},
		{
			//首页
			path: '/coreStrengths',
			name: 'coreStrengths',
			component: (resolve) => require(['@/views/coreStrengths.vue'], resolve),
		},
		{
			path: '/introduction',
			name: 'introduction',
			component: (resolve) => require(['@/views/introduction.vue'], resolve),
		},
		//introduction
	],
})
